import { render, staticRenderFns } from "./EditeSub.vue?vue&type=template&id=139204e0&scoped=true&"
import script from "./EditeSub.vue?vue&type=script&lang=js&"
export * from "./EditeSub.vue?vue&type=script&lang=js&"
import style0 from "./EditeSub.vue?vue&type=style&index=0&id=139204e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139204e0",
  null
  
)

export default component.exports